import { faqBreadcrumb, defBreadcrumb } from "../../../data/DataBreadcrumb";
import Answers from "../../../components/Faq/Answers";
import { pertanyaanUmumMeta } from "../../../data/DataMetatags";
import React from "react";
import TopicWrapperProps from "../../../components/Faq/TopicWrapper";
import axios from "axios";
import { env } from "src/utils/env";

const TopicItem = ({
  asPath,
  breadcrumb,
  topicBreadcrumb,
  questions,
  pageTitle,
  description,
  topicId,
  topic_id,
  topic_item,
  faqData,
  header,
}) => {
  return (
    <TopicWrapperProps
      pageTitle={pageTitle}
      asPath={asPath}
      description={description}
      breadcrumb={breadcrumb}
      topicBreadcrumb={topicBreadcrumb}
      questions={questions}
      topicId={topicId}
      header={header}
    >
      <Answers data={faqData} topicId={topic_id} topicItem={topic_item} />
    </TopicWrapperProps>
  );
};

TopicItem.getInitialProps = async ({ res, query, asPath }) => {
  const { title, description } = pertanyaanUmumMeta;
  const { topicId, topicItem, header } = query;
  const topic_id = topicId.replace(/-/g, "-");
  const topic_item = topicItem.replace(/-/g, "-");

  const { status: questionsStatus, data: questionsData } = await axios.get(
    `${env.baseUrl}/api/v1/kentico/questions`,
    {
      headers: {
        "Content-Type": "application/json",
        Authorization: `${env.auth}`,
      },
    }
  );

  if (questionsStatus === 200) {
    const { status: topicFaqStatus, data: topicFaqData } = await axios.get(
      `${env.baseUrl}/api/v1/kentico/topic-faq`,
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `${env.auth}`,
        },
        params: {
          topicId: topicId,
        },
      }
    );

    if (topicFaqStatus === 200) {
      const topic = await topicFaqData.data.find(
        ({ key }) => key === topicItem
      );

      const pageTitle = `${title} - ${topic?.question}`;

      const breadcrumb = [
        ...defBreadcrumb,
        {
          "@type": "ListItem",
          position: "2",
          item: {
            "@id": process.env.baseUrl + "/pertanyaan-umum",
            name: "pertanyaan-umum",
          },
        },
        {
          "@type": "ListItem",
          position: "3",
          item: {
            "@id": process.env.baseUrl + "/pertanyaan-umum/" + topicId,
            name: topicFaqData.title,
          },
        },
        {
          "@type": "ListItem",
          position: "4",
          item: {
            "@id": process.env.baseUrl + asPath,
            name: pageTitle,
          },
        },
      ];

      const topicBreadcrumb = [
        ...faqBreadcrumb,
        {
          page: topicFaqData?.title,
          href: `/pertanyaan-umum/${topicId}`,
          to: `/pertanyaan-umum/${topicId}`,
        },
        {
          page: topic?.question,
          href: `/pertanyaan-umum/${topicId}/${topicItem}`,
          to: `/pertanyaan-umum/${topicId}/${topicItem}`,
        },
      ];

      return {
        asPath,
        breadcrumb,
        topicBreadcrumb,
        questions: questionsData,
        pageTitle,
        description,
        topicId,
        topic_id,
        topic_item,
        faqData: topicFaqData.data,
        header,
      };
    } else {
      if (res) {
        res.writeHead(301, {
          Location: `/halaman-tidak-ditemukan?q=pertanyaan-umum/${topicId}/${topicItem}`,
        });
        res.end();
      }
    }
  } else {
    if (res) {
      res.writeHead(301, {
        Location: `/halaman-tidak-ditemukan?q=pertanyaan-umum`,
      });
      res.end();
    }
    return;
  }
};

export default TopicItem;
